// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-2fd90e23]{display:block;width:100%;height:100%;background-color:#fff;border-radius:10px}.livehead[data-v-2fd90e23]{border-top-left-radius:10px;border-top-right-radius:10px;color:#fff;text-align:center;font-size:24px;line-height:26px;padding-top:12px}.label-text[data-v-2fd90e23]{font-size:14px;text-align:left}", ""]);
// Exports
module.exports = exports;
